"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BACKSPACE_CHARCODE = 8;
exports.TAB_CHARCODE = 9;
exports.ENTER_CHARCODE = 13;
exports.SPACE_CHARCODE = 32;
exports.PAGE_UP_CHARCODE = 33;
exports.PAGE_DOWN_CHARCODE = 34;
exports.END_CHARCODE = 35;
exports.HOME_CHARCODE = 36;
exports.LEFT_ARROW_CHARCODE = 37;
exports.UP_ARROW_CHARCODE = 38;
exports.RIGHT_ARROW_CHARCODE = 39;
exports.DOWN_ARROW_CHARCODE = 40;
exports.DELETE_CHARCODE = 46;
exports.K_CHARCODE = 75;
exports.ESC_CHARCODE = 27;
//# sourceMappingURL=KeyboardCharCodes.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-hotkeys/lib/utils/KeyboardCharCodes.js
// module id = 634
// module chunks = 2 3 63 105 106 107